import Header from '../../../__Layout/Header';
import React , {useState,useEffect} from "react";

import { useForm } from "react-hook-form";
import * as Yup from "yup";

import { yupResolver } from "@hookform/resolvers/yup";
export default function PayOnline() {
     useEffect(() => {
         window.location.href = "https://www.qhseinternational.com/payment";

    }, []);
    const validationSchema = Yup.object().shape({
        first_name: Yup.string().required("first name fields is required"),
        last_name: Yup.string().required("last name fields is required"),
        phone: Yup.string().required("phone number fields is required"),
        email: Yup.string().required("email fields is required"),
        amount: Yup.string().required("amount fields is required"),
        course: Yup.string().required("course fields is required"),
    }); 
    let defaultValues = { name: ""};
    const methods = useForm({
      mode: "onTouched",
      resolver: yupResolver(validationSchema),
      defaultValues,
    });
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = methods;
    const onSubmit = (values,e) => {
        const { first_name,last_name,course,email,phone,amount} = values;
        window.location.href = "https://www.qhseinternational.com/online_payment/ccavRequestHandler.php?first-name="+first_name+"&last-name="+last_name+"&amount="+amount+"&your-email="+email+"&phone="+phone+"&merchant_param1="+course;
    };
      return (
        <div className="vehicleCategories">
            <Header />
            <main id="main" className="main">
                <div className="card">
                    <div className="card-body">
                        <h5 className="card-title">Online Payment</h5>
                            <section className="section">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <h5 className="card-title">Pay Online</h5>
                                                    <form onSubmit={handleSubmit(onSubmit)} >
                                                        <div className="row mb-3">
                                                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">first name</label>
                                                            <div className="col-sm-10">
                                                                <input type="name" {...register("first_name")} className="form-control" />
                                                                <span className="text-danger">{errors.first_name?.message}</span>
                                                            </div>
                                                        </div>
                                                        <div className="row mb-3">
                                                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">last name</label>
                                                            <div className="col-sm-10">
                                                                <input type="name" {...register("last_name")} className="form-control" />
                                                                <span className="text-danger">{errors.last_name?.message}</span>
                                                            </div>
                                                        </div>
                                                        <div className="row mb-3">
                                                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">mobile number</label>
                                                            <div className="col-sm-10">
                                                                <input type="number" {...register("phone")} className="form-control" />
                                                                <span className="text-danger">{errors.phone?.message}</span>
                                                            </div>
                                                        </div>
                                                        <div className="row mb-3">
                                                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">email</label>
                                                            <div className="col-sm-10">
                                                                <input type="email" {...register("email")} className="form-control" />
                                                                <span className="text-danger">{errors.email?.message}</span>
                                                            </div>
                                                        </div>
                                                        <div className="row mb-3">
                                                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">course name</label>
                                                            <div className="col-sm-10">
                                                                <input type="text"  {...register("course")} className="form-control" />
                                                                <span className="text-danger">{errors.course?.message}</span>
                                                            </div>
                                                        </div>
                                                        <div className="row mb-3">
                                                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">amount</label>
                                                            <div className="col-sm-10">
                                                                <input type="number" {...register("amount")} className="form-control" />
                                                                <span className="text-danger">{errors.amount?.message}</span>
                                                            </div>
                                                        </div>
                                                        <div className="row mb-3">
                                                            <label className="col-sm-2 col-form-label"></label>
                                                            <div className="col-sm-10">
                                                                <button type="submit" className="btn btn-warning w-100" >Pay Online</button>
                                                            </div>
                                                        </div>
                                                    </form>   
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>  
                    </div>
                </div>
            </main>
        </div>
    );
}
